import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SortingState } from '@tanstack/react-table';
import {
  useAuthUserRestaurant,
  useGetAllProductOfferOrdersQuery,
} from '@durma-soft/gros-sdk';

import { Modal } from '@/components/shared/modal';
import { Spinner } from '@/components/shared/spinner';
import { DataTable } from '@/components/shared/data-table';

import { allOrderColumns } from '@/config/restaurant/platform-product-offers';

interface ClosedOrdersModalProps {
  onClose: () => unknown;
}

export const ClosedOrdersModal = ({ onClose }: ClosedOrdersModalProps) => {
  const { t } = useTranslation();
  const restaurant = useAuthUserRestaurant();
  const [sorting, setSorting] = useState<SortingState>([]);

  const orders = useGetAllProductOfferOrdersQuery({
    restaurant_id: restaurant.id,
    status: 'closed',
  });

  const columns = useMemo(() => allOrderColumns(t), [t]);

  return (
    <Modal
      isModalOpen
      closeModal={onClose}
      title={t('order-overview.closed-orders')}
      className="sm:max-w-6xl"
    >
      <div className="max-h-[70vh] overflow-y-auto">
        {orders.isLoading ? (
          <div className="flex justify-center p-4">
            <Spinner />
          </div>
        ) : orders.isError ? (
          <p className="p-4 text-center text-sm text-destructive">
            {t('common.error')}
          </p>
        ) : (orders.data ?? []).length === 0 ? (
          <p className="p-4 text-center text-sm text-muted-foreground">
            {t('order-overview.closed-empty')}
          </p>
        ) : (
          <DataTable
            columns={columns}
            data={orders.data ?? []}
            sorting={sorting}
            setSorting={setSorting}
          />
        )}
      </div>
    </Modal>
  );
};
